module.exports = __webpack_public_path__ + "img/green2.7c5782f1.jpg";